import { InjectionToken } from "@angular/core";
import { ProductDetailThumbnailDialog } from "projects/shared/lib/components/shared/product/detail/thumbnail-dialog/product-detail-thumbnail-dialog.model";


export abstract class IProductDetailThumbnailDialogService {

  abstract productDetailThumbnailDialogShow(productDetailThumbnailDialog: ProductDetailThumbnailDialog): unknown;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IProductDetailThumbnailDialogServiceToken = new InjectionToken<IProductDetailThumbnailDialogService>('IProductDetailThumbnailDialogServiceToken');
